module.exports = __webpack_public_path__ + "img/atn-logo.f9700ea3.jpg";